import Swal from 'sweetalert2';
import i18next from 'i18next';

interface Params {
  type: 'error' | 'success' | 'warning' | 'info',
  title?: string | null | undefined;
  code?: string;
  message?: string;
  btnConfirmMsg?: string;
  showCancelButton?: boolean;
  cancelButtonText?: string;
  btnCancelMsg?: string;
  showBtnCancel?: boolean;
  html?: string; 
}

function tranSl(text:string) {
  return i18next.t(text);
}

/**
 * Shows a success/info/warning/error alert dialog.
 * @param params - Alert config (type, title, message, confirm button text)
 * @returns Promise resolving when user confirms
 */
export function AlertSuccess(params: Params) {
  return Swal.fire({
    title: tranSl(`${params.title}`) || '',
    text: params.message ? tranSl(params.message) : '',
    buttonsStyling: false,
    icon: params.type,
    iconHtml: '',
    confirmButtonText: params.btnConfirmMsg ? params.btnConfirmMsg : i18next.t('CONFIRM')
  });
}

/**
 * Shows a confirmation dialog with confirm and cancel buttons.
 * @param params - Dialog config (title, message, button labels)
 * @returns Promise resolving to user choice (isConfirmed)
 */
export function AlertConfirm(params: Params) {
  return Swal.fire({
    title: tranSl(`${params.title}`) || i18next.t('CONFIRM'),
    icon: 'question',
    text: params.message ? tranSl(params.message) : '',
    buttonsStyling: false,
    showCancelButton: true,
    confirmButtonText: params && params.btnConfirmMsg ? tranSl(`${params.btnConfirmMsg}`) : i18next.t('CONFIRM'),
    cancelButtonText: params && params.btnCancelMsg ? tranSl(`${params.btnCancelMsg}`) : i18next.t('Cancel'),
    reverseButtons: true
  });
}

/**
 * Shows a custom alert with configurable cancel button visibility.
 * @param params - Alert config (type, title, message, buttons, showBtnCancel)
 * @returns Promise resolving when user confirms or cancels
 */
export function AlertCustom(params: Params) {
  const status = true;
  let cancelBtn = true;
  if (params.showBtnCancel === !status) {
    cancelBtn = false;
  }
  return Swal.fire({
    title: tranSl(`${params.title}`) || i18next.t('ERROR'),
    text: params.message ? tranSl(params.message) : '',
    buttonsStyling: false,
    showCancelButton: cancelBtn,
    icon: params.type,
    iconHtml: '',
    confirmButtonText: params && params.btnConfirmMsg ? tranSl(`${params.btnConfirmMsg}`) : i18next.t('CONFIRM'),
    cancelButtonText: params && params.btnCancelMsg ? tranSl(`${params.btnCancelMsg}`) : i18next.t('Cancel'),
    reverseButtons: true
  });
}